import { reportModalCtaClick } from '../../../bi/bi';
import { Modals } from '../../../types';
import { useModalsAndWindow } from '../../../context/ModalsAndWindowContext';
import { useInstallerContext } from '../../../context/InstallerContext';
export const useConsentModalOnClicks = () => {
  const {
    modals
  } = useModalsAndWindow();
  const {
    preInstallationData: {
      isAppAlreadyInstalled
    }
  } = useInstallerContext();
  const onAgreeButtonClick = () => {
    reportModalCtaClick({
      ctaName: isAppAlreadyInstalled ? 'agree-and-update' : 'agree-and-add',
      modalType: Modals.userConsent
    });
    modals.userConsent.close({
      answer: 'PROCEED'
    });
  };
  const onCloseButtonClick = () => {
    reportModalCtaClick({
      ctaName: 'close',
      modalType: Modals.userConsent
    });
    modals.userConsent.close({
      answer: 'CANCELED'
    });
  };
  return {
    onAgreeButtonClick,
    onCloseButtonClick
  };
};
//# sourceMappingURL=useConsentModalOnClicks.js.map